import TipoIndicador from "..";
import ADF from "entity/Indicador/ADF";
import ADH from "entity/Indicador/ADH";
import ADN from "entity/Indicador/ADN";
import AH from "entity/Indicador/AH"
import AVL from "entity/Indicador/AVL";
import TAH from "entity/Indicador/TAH";
import UQL from "entity/Indicador/UQL";

export default class TratosPlanta extends TipoIndicador {
    static get abbrev() {
        return 'tratosCanaPlanta';
    }

    static get fullName() {
        return "Tratos / Cana Planta";
    }

    static get field() {
        return 'tratosCanaPlanta';
    }

    static get indicadores() {
        return [ADF, AH, TAH, ADH, ADN, AVL, UQL]
    }
}
